__turbopack_context__.v({
  "avatar": "avatar-row-module-scss-module__H1xgya__avatar",
  "avatar-row": "avatar-row-module-scss-module__H1xgya__avatar-row",
  "avatar-scroll-container": "avatar-row-module-scss-module__H1xgya__avatar-scroll-container",
  "avatar-wrapper": "avatar-row-module-scss-module__H1xgya__avatar-wrapper",
});
